<template>
  <div class="main">
    <el-dialog
      v-loading="loading"
      :visible.sync="isSavePic"
      top="30vh"
      :center="false"
      width="440px"
      style="border-radius:15px;"
      :close-on-click-modal="true"
      :append-to-body="true"
      :before-close="close"
    >
      <div slot="title" class="title">生成长图</div>
      <div class="content">
        <div>图文生成图片须知：</div>
        <div>
          全文生成图片后，可能会涉及到图片、文字的版权问题，如果您是用于商业宣传，请确保您的图片、字体可商用
        </div>
        <div class="saveBtn">
          <el-button @click="savePic(480)" type="info" round
            >生成长图(宽480px)</el-button
          >
          <el-button @click="savePic(640)" type="primary" round
            >生成长图(宽640px)</el-button
          >
          <el-button @click="savePic(1024)" type="success" round
            >生成长图(宽1024px)</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "SavePicture",
  props: {
    isSavePic: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState("editorControl", ["isSaveLength"])
  },
  methods: {
    ...mapMutations("editorControl", ["setSaveLength"]),
    close() {
      this.$emit("closeSavePic", false);
    },
    savePic(length) {
      this.setSaveLength(length);
      this.$emit("closeSavePic", false);
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
.content {
  font-size: 12px;
  div {
    line-height: 25px;
  }
  .saveBtn {
    margin-top: 20px;
    text-align: center;
  }
}
/deep/.el-dialog__body {
  padding: 10px 10px 30px 10px;
}
/deep/.el-dialog__header {
  padding: 10px !important;
  border-bottom: 1px solid #f4f4f4;
}
/deep/.el-dialog__headerbtn {
  top: 10px;
}
/deep/.el-button {
  font-size: 12px;
  padding: 10px 10px;
}
/deep/.el-button--info {
  background-color: @blue;
  color: #fff;
  border-color: @blue;
  &:hover {
    background-color: #1675ff;
    color: #fff;
    border-color: #1675ff;
  }
}
</style>
